const mapExpressPaymentMethods = (paymentMethods) => (paymentMethods ?? []).map((paymentMethod) => ({
  name: paymentMethod?.name,
  psp: paymentMethod?.psp,
  brands: paymentMethod?.brands,
  configuration: paymentMethod?.configuration
}));
export {
  mapExpressPaymentMethods
};
//# sourceMappingURL=express-payment-methods.js.map
